export function pixeliseValue(val) {
  return val ? `${val}px` : '';
}

export default {};
